import React, { useState, useEffect } from 'react';
import { useGlobal } from 'reactn';
import CryptoJS from 'crypto-js';
import dollarIcon from '../../assets/dollarIcon.png';
import Button from '../../common/button/Button';

import api from '../../../api';

const SPEED_PAY_URL = process.env.REACT_APP_SPEEDPAY_URL;

const Speedpay_Footer = ({ customerAccount, btnClassname }) => {
  const [user] = useGlobal('user');
  const [encryption, setEncryption] = useState('');
  const [ts, setTs] = useState(null);
  const [iV, setIV] = useState(null);
  const [key, setKey] = useState(null);
  const { id, email } = user;

  const getKey = async () => {
    const res = await api.getSpeedpayKey();
    if (res.error) {
      console.log({ SpeedpayKeyError: res.error });
    }
    setKey(res.speedpayKey);
  };

  useEffect(() => {
    getKey();
  }, []);

  const renderSpeedPay = () => {
    const keyBase64 = key;
    const timestamp = Date.now();
    const account = customerAccount.ACCOUNT;
    const payload = `sp_credit_account=${account}|^|Timestamp=${timestamp}|^|EmailAddress=${email}|^|ID=${id}`;

    var encrypted = CryptoJS.AES.encrypt(
      payload,
      CryptoJS.enc.Base64.parse(keyBase64),
      {
        iv: CryptoJS.lib.WordArray.random(16 /* bytes */),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    var iv = CryptoJS.enc.Base64.stringify(encrypted.iv);
    setEncryption(encrypted);
    setTs(timestamp);
    setIV(iv);
  };

  // Extract the values we need
  // var post_data = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

  return (
    <form action={SPEED_PAY_URL} method="POST">
      <input
        type="hidden"
        id="iv"
        name="IV"
        value={iV === null ? undefined : iV}
      />
      <input type="hidden" name="post_data" id="postData" value={encryption} />
      <input
        type="hidden"
        name="timestamp"
        id="timeStamp"
        value={ts === null ? undefined : ts}
      />
      <Button
        htmlType="submit"
        iconUrl={dollarIcon}
        className="w-full"
        onClick={renderSpeedPay}
      >
        Make a Payment <br/>($1.45 Fee/Transaction)
      </Button>
    </form>
  );
};

export default Speedpay_Footer;
